import { render } from "./ReviewStatusDropdown.vue?vue&type=template&id=24784304"
import script from "./ReviewStatusDropdown.vue?vue&type=script&lang=js"
export * from "./ReviewStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__